export default __webpack_public_path__ + "imgs/temp/massue3.svg";